import { z } from 'zod'

export const TriggerPayrollSchema = z.object({
  clientPublicKey: z.string(),
  payrollDates: z.array(z.any()),
})
